import { render, staticRenderFns } from "./CardMaquinaCompacta.vue?vue&type=template&id=5523b6b4&scoped=true&"
import script from "./CardMaquinaCompacta.vue?vue&type=script&lang=js&"
export * from "./CardMaquinaCompacta.vue?vue&type=script&lang=js&"
import style0 from "./CardMaquinaCompacta.vue?vue&type=style&index=0&id=5523b6b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5523b6b4",
  null
  
)

export default component.exports